import jsdk from '../../jsdk';
import t from 'tcomb';
import UUID from '../../web/domain/UUID';
import URL from '../../web/domain/URL';
import Reducer from '../../web/domain/Reducer';

const Gplus_Input = t.struct({
  id: UUID,
  url: URL,
  gplus_url: t.Str
}, 'Gplus_Input');
/*
export default function Gplus_Input(id, url, gplus_url) {
  jsdk.assert(jsdk.UUID.is(id));
  jsdk.assert(jsdk.URL.is(url));
  jsdk.assert(jsdk.Str.is(gplus_url));
  this.type = 'reducer/gplus';
  this.id = id;
  this.url = url;
  this.gplus_url = gplus_url;
  return jsdk.freeze(this);
}

Gplus_Input.is = function(x) {
  return x instanceof Gplus_Input;
};

Gplus_Input.of = function(x) {
  jsdk.assert(jsdk.Obj.is(x));
  return new Gplus_Input(
    jsdk.UUID.of(x.id),
    jsdk.URL.of(x.url),
    jsdk.Str.of(x.gplus_url)
  );
};
*/
Gplus_Input.prototype.to_html = function(value, locale) {
  var id = this.id;
  var src = jsdk.to_url(this.gplus_url, {
    id: id,
    url: this.url,
    locale: locale
  });
  var html = '<div class="gplus-containter"><iframe src="' + src + '"></iframe></div>';
  return jsdk.Form.wrap_input(id, html, {});
};

Gplus_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Gplus_Input.prototype.value = function(locale) {
  var id = this.id;
  var b = Reducer.has_gplus(id);
  var validation = new jsdk.Bool_Schema([true]).validate(b);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

jsdk.Form.add_input('reducer/gplus', Gplus_Input);


export default Gplus_Input;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/reducer/Gplus_Input.js
 **/